const host = '',
  project = '',
  prefix = host + project +'/api/';

let apis = {
  Login: prefix + 'User/Login', //登录
  Exit: prefix + 'User/Exit', //退出登录
  LoginWX: prefix + 'User/LoginWX', //微信登录
  GetCode: prefix + 'User/GetCode', //获取code
  WxBind: prefix + 'User/WxBind', //绑定微信
  sign: prefix + 'User/sign',  //签到
  GetSign: prefix + 'User/GetSign',  //获取签到
  GetWorkList: prefix + 'Work/GetWorkList',  //项目大厅
  GetWorkDetail: prefix + 'Work/GetWorkDetail',  //查看工作
  GetMyWork: prefix + 'Work/GetMyWork',  //我的工单
  ClaimJob: prefix + 'Work/ClaimJob',  //领取工单
  OperationJob: prefix + 'Work/OperationJob',  //操作办理
  GetUserList: prefix + 'User/GetUserList',  //人员列表
  EditRefund: prefix + 'Work/EditRefund',  //编辑退款申请单
  GetRefund: prefix + 'Work/GetRefund',  //编辑退款申请单
  GetMyMsg: prefix + 'Work/GetMyMsg',  //获取消息
  ReviewRefund: prefix + 'Work/ReviewRefund',  //退费
  
  ReadOperation: prefix + 'Work/ReadOperation',  //已读消息
  GetAgentCount: prefix + 'Work/GetAgentCount',  //待处理数
  DelMsg: prefix + 'Work/DelMsg',  //删除消息
  GetOvertime: prefix + 'Personnel/GetOvertime',  //获取加班，请假列表
  EditOvertime: prefix + 'Personnel/EditOvertime',  //编辑加班，请假表
  OvertimeDetail: prefix + 'Personnel/OvertimeDetail',  //加班，请假数据回显
  GetReimbursement: prefix + 'Personnel/GetReimbursement',  //报销单
  EditReimbursement: prefix + 'Personnel/EditReimbursement',  //编辑报销单
  ReimbursementDetail: prefix + 'Personnel/ReimbursementDetail',  //报销单数据回显
  GetTravelExpenses: prefix + 'Personnel/GetTravelExpenses',  //差旅报销列表
  EditTravelExpenses: prefix + 'Personnel/EditTravelExpenses',  //编辑差旅报销
  TravelExpensesDetail: prefix + 'Personnel/TravelExpensesDetail',  //差旅报销数据回显
  ReviewOvertimeOrders: prefix + 'Personnel/ReviewOvertimeOrders',  //审核加班请假单
  ReviewOvertimeOrder: prefix + 'Personnel/ReviewOvertimeOrder',  //审核加班请假单不带s
  ReviewReimbursement: prefix + 'Personnel/ReviewReimbursement',  //审核报销单
  ReviewTravelExpenses: prefix + 'Personnel/ReviewTravelExpenses',  //审核差旅报销单
  Getreturn: prefix + 'Personnel/Getreturn',  //判断是否可以退回
  
  GetFiles: prefix + 'Personnel/GetFiles',  //文件列表
  GetFile: prefix + 'Personnel/GetFile',  //最新文件列表

  UploadFiles: prefix + 'Personnel/UploadFiles',  //上传附件
  UploadFile: prefix + 'Personnel/UploadFile',  //最新上传附件
  DelFiles: prefix + 'Personnel/DelFiles',  //删除附件
  eliminate: prefix + 'Personnel/eliminate',  //销假
  eliminates: prefix + 'Personnel/eliminates',  //新版销假
  EditReimburse: prefix + 'Personnel/EditReimburse',  //统计报销

  GetHoliday: prefix + 'Statistics/GetHoliday',  //假期
  GetSeniority: prefix + 'Statistics/GetSeniority',  //获取工龄
  SetSeniority: prefix + 'Statistics/SetSeniority',  //设置工龄
  GetReimbursements: prefix + 'Statistics/GetReimbursement',  //报销统计表
  EditJob: prefix + 'Work/EditJob',  //创建工单
  GetHistoryList: prefix + 'Work/GetHistoryList',  //历史列表
  EditPwd: prefix + 'User/EditPwd',  //修改密码
  DelMsg: prefix + 'Work/DelMsg',  //修改密码
  GetClockInTime: prefix + 'Statistics/GetClockInTime',  //获取打卡事假
  GetEmployeeStatus: prefix + 'User/GetEmployeeStatus',  //获取员工状态
  GetMyHoliday: prefix + 'Statistics/GetMyHoliday',  //考勤 其他
  GetMsgdetailed: prefix + 'Work/GetMsgdetailed',  //消息页面获取附件
  gettask: prefix + 'Statistics/gettask',  //值日表
  GetMsg: prefix + 'Statistics/GetMsg',  //消息弹窗提醒信息
  EditRead: prefix + 'Statistics/EditRead',  //关闭消息弹窗提醒
  GetOnlineNumb: prefix + 'Statistics/GetOnlineNumb',  //在线人数

  IsDelCourse: prefix + 'work/IsDelCourse',  //退费列表页面的删课按钮
  DelJob: prefix + 'Work/DelJob',  //删除工单
  WorkUploadFiles: prefix + 'Work/UploadFiles',  //工单中的新增附件
  GetHolidayLogs: prefix + 'Statistics/GetHolidayLogs',  //统计中的查询假期详细
  GetHolidayLogs2: prefix + 'Statistics/GetHolidayLogs2',  //统计中的查询假期详细
  GetSchedule: prefix + 'User/GetSchedule',  //查询日程
  EditSchedule: prefix + 'User/EditSchedule',  //提交日程备注信息
  GetMealAllowance: prefix + 'Statistics/GetMealAllowance',  //餐补

  GetClockInState: prefix + 'Statistics/GetClockInState',  //打卡状态
  GetClockInabnormal: prefix + 'Statistics/GetClockInabnormal',  //异常
  GetClockInTimes: prefix + 'Statistics/GetClockInTimes',  //打卡详情
  GetMyHolidays: prefix + 'Statistics/GetMyHolidays',  //考勤 其他
  GetProvinceTime: prefix + 'Statistics/GetProvinceTime',  //各省时间
  GetProvinceRule: prefix + 'Statistics/GetProvinceRule',  //各省规则
  GetPath: prefix + 'Personnel/GetPath',  //获取下载文件地址
  Getdholidays: prefix + 'Personnel/Getdholidays',  //万年历
  days: prefix + 'Personnel/days',  //天数
  // days: prefix + 'ReviewAccess/days',  //天数
  
  EditGoOut: prefix + 'Personnel/EditGoOut',  //外出单
  EditIsFp: prefix + 'Work/EditIsFp',  //消息查看收起状态
  Getbirthday: prefix + 'User/Getbirthday',  //获取所有人员的生日
  DelRefund: prefix + 'Work/DelRefund',  //删除退费信息

  GetPayertotal: prefix + 'Work/GetPayertotal',  //删除退费金额
  
  // 另一家单位的审核接口
  GetOvertimeTwo: prefix + 'ReviewAccess/GetOvertime',  //
  ReviewOvertimeOrderTwo: prefix + 'ReviewAccess/ReviewOvertimeOrder',  //审核加班请假单不带s
  OvertimeDetailTwo: prefix + 'ReviewAccess/OvertimeDetail',  //加班，请假数据回显
  daysTwo: prefix + 'ReviewAccess/days',  //天数
  eliminateTwo: prefix + 'ReviewAccess/eliminate',  //销假
  GetReimbursementTwo: prefix + 'ReviewAccess/GetReimbursement',  //报销单
  ReimbursementDetailTwo: prefix + 'ReviewAccess/ReimbursementDetail',  //报销单数据回显
  ReviewReimbursementTwo: prefix + 'ReviewAccess/ReviewReimbursement',  //审核报销单
  GetreturnTwo: prefix + 'ReviewAccess/Getreturn',  //判断是否可以退回
  GetTravelExpensesTwo: prefix + 'ReviewAccess/GetTravelExpenses',  //差旅报销列表
  TravelExpensesDetailTwo: prefix + 'ReviewAccess/TravelExpensesDetail',  //差旅报销数据回显
  ReviewTravelExpensesTwo: prefix + 'ReviewAccess/ReviewTravelExpenses',  //审核差旅报销单
  // 另一家单位的统计接口
  GetHolidayTwo: prefix + 'ReviewAccess/GetHoliday',  //假期
  GetHolidayLogs2Two: prefix + 'ReviewAccess/GetHolidayLogs2',  //统计中的查询假期详细
  GetRbstatistics: prefix + 'ReviewAccess/GetRbstatistics',  //报销统计表
  EditReimburseTwo: prefix + 'ReviewAccess/EditReimburse',  //统计报销
  GetClockInStateTwo: prefix + 'ReviewAccess/GetClockInState',  //打卡状态
  GetClockInTimesTwo: prefix + 'ReviewAccess/GetClockInTimes',  //打卡详情
  GetUserListTwo: prefix + 'ReviewAccess/GetUserList',  //人员列表
  GetClockInabnormalTwo: prefix + 'ReviewAccess/GetClockInabnormal',  //异常
  GetMealAllowanceTwo: prefix + 'ReviewAccess/GetMealAllowance',  //餐补

  applyeliminates: prefix + 'Personnel/applyeliminates',  //申请销假
  Geteliminates: prefix + 'Personnel/Geteliminates',  //销假列表

  // 域名管理
  GetOperations: prefix + 'User/GetOperations',  //域名列表
  DelOperations: prefix + 'User/DelOperations',  //删除域名
  EditOperations: prefix + 'User/EditOperations',  //新增域名

  // 活动
  GetActivitys: prefix + 'Statistics/GetActivitys',  //查看活动
  registration: prefix + 'Statistics/registration',  //报名
  RevokeActivity: prefix + 'Statistics/RevokeActivity',  //撤销报名
  editActivity: prefix + 'Statistics/editActivity',  //编辑活动
  GetActivitysDetailed: prefix + 'Statistics/GetActivitysDetailed',  //查看活动详情
  DelActivity: prefix + 'Statistics/DelActivity',  //删除活动
  
  // 运维
  getOperatLog: prefix + 'User/getOperatLog',  //运维日志
  EditOperatLog: prefix + 'User/EditOperatLog',  //编辑运维日志
  DelOperatLog: prefix + 'User/DelOperatLog',  //删除运维日志
  
  // 验证码
  validateCode_loadImage: prefix + 'Statistics/validateCode_loadImage',  //录音验证码
  c4006_login: prefix + 'Statistics/c4006_login',  //登录输入验证码
  Getc4006List: prefix + 'Statistics/Getc4006List',  //获取录音列表
  
  // 餐补明细
  GetMealAllowanceDetailed: prefix + 'Statistics/GetMealAllowanceDetailed',
  
  // 课件审核
  Getkcys: prefix + 'work/Getkcys',

  // 汇款
  UploadHK: prefix + 'Work/UploadHK', //上传汇款明细
  GetHK: prefix + 'Work/GetHK',  //汇款列表
  UploadPersonnel: prefix + 'Work/UploadPersonnel',  //上传人员名单
  ReviewHK: prefix + 'Work/ReviewHK',  //审核汇款

  DelHK: prefix + 'Work/DelHK',  //删除汇款
  editHK: prefix + 'Work/editHK',  //备注

  // 消息提醒
  GetPendingform: prefix + 'Personnel/GetPendingform',  //马姐消息红点提醒(内部审核)
  
  GetPendingformTwo: prefix + 'ReviewAccess/GetPendingformACCESS',  //马姐消息红点提醒(外部审核)

  GetRefundNumb: prefix + 'work/GetRefundNumb',  //马姐消息红点提醒(退费)
  
  
  // 打卡备注
  EditClockInRemark: prefix + 'statistics/EditClockInRemark',
  // 删除报销
  DelReimbursement: prefix + 'Personnel/DelReimbursement',

  // 打卡时间修改成17:30
  GetClockInConfig: prefix + 'statistics/GetClockInConfig',

  // 课件审核
  // 获取视频上传凭证
  CreateUploadVideo: prefix + 'Course/CreateUploadVideo',
  // 刷新上传凭证
  RefreshUploadVideo: prefix + 'Course/RefreshUploadVideo',
  //申报新课
  editcourse: prefix + 'Course/editcourse',
  // 课程审核
  coursereview: prefix + 'Course/coursereview',
  //获取授课人信息
  teacherinfo: prefix + 'Course/teacherinfo',
  //触发视频上传
  RuleUploadFile: prefix + 'Course/RuleUploadFile',
  // 预约拍摄时间
  editshoot: prefix + 'Course/editshoot',
  // 痕迹
  courselogs: prefix + 'Course/courselogs',
  // 催一下
  Hurryup: prefix + 'Course/Hurryup',
  // 教材审核 拍摄录制 上传
  uploadTextbook: prefix + 'Course/uploadTextbook',
  // 课程详细
  getcoursedetailed: prefix + 'Course/getcoursedetailed',
  //删除文档
  delTextbook: prefix + 'Course/delTextbook',
  //删除视频
  delvod: prefix + 'Course/delvod',
  // 提交拍摄录制
  submitshooting: prefix + 'Course/submitshooting',
  // 提交初审/终审
  submitcourse: prefix + 'Course/submitcourse',
  //入库
  warehousing: prefix + 'Course/warehousing',
  // 审核不通过查询原因
  reviewreason: prefix + 'Course/reviewreason',
  
  // 课程管理
  coursemanage: prefix + 'Course/coursemanage',
  // 拍摄时间表
  shootinfo: prefix + 'Course/shootinfo',
  // 课程管理待处理数量
  MyPending: prefix + 'Course/MyPending',
  // 拍摄待处理数量
  myshooting: prefix + 'Course/myshooting',
  // 删除课程管理
  delcoursemanage: prefix + 'Course/delcoursemanage',
  // 历年课程
  Pastcourses: prefix + 'Course/Pastcourses',
  // 视频详情
  Pastcoursesdetailed: prefix + 'Course/Pastcoursesdetailed',
  // 视频播放
  GetPlayInfo: prefix + 'Course/GetPlayInfo',
  // 删除拍摄列表
  delshoot: prefix + 'Course/delshoot',
  // 授课人列表
  teacherlist: prefix + 'Course/teacherlist',
  // 课程编号是否存在
  iscode: prefix + 'Course/iscode',
  // 导出历年课程的excel
  Pastcoursesexcel: prefix + 'Course/Pastcoursesexcel',
  // 各省使用列表
  PastProvincecourses: prefix + 'Course/PastProvincecourses',
  // 导出各省使用excel
  PastProvincecoursesExcel: prefix + 'Course/PastProvincecoursesExcel',
  // 导出课程管理excel
  excelcoursemanage: prefix + 'Course/excelcoursemanage',
  // 修改拍摄信息
  operationshootinfo: prefix + 'Course/operationshootinfo',
  // 各省科目类别
  PastProvince: prefix + 'Course/PastProvince',
  // 纠错删除
  delcorrection: prefix + 'Course/delcorrection',
  // 纠错上传
  uploadcorrection: prefix + 'Course/uploadcorrection',
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
};
export default apis;



// WEBPACK FOOTER //
// ./src/api/index.js